import * as React from "react";
import { Row, Col, Button } from "antd";
import CartContext from "Context/CartContext";

export interface Props {
    children?: React.ReactNode,
    goToCartPage: Function
}

export interface State {
}

export default class ProceedToCartButton extends React.Component<Props, State> {
    static contextType = CartContext;
    context!: React.ContextType<typeof CartContext>;
    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    render() {
        const { goToCartPage } = this.props;
        const context = this.context.data?.cartItems?.length;
        return (
            <Row>
                <Col>
                    <Button onClick={() => goToCartPage()} style={{ backgroundColor: context! > 0 ? "#77DD2E" : "", color: context! > 0 ? "white" : "" }}> Proceed to Checkout </Button>
                </Col>
            </Row>
        )
    }
}
